import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'

import store from 'store'
import { PaintingProvider } from 'providers/PaintingProvider'
import { StatusProvider } from 'providers/ApiStatusProvider'

ReactDOM.render(
  <Provider store={store}>
    <PaintingProvider>
      <StatusProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </StatusProvider>
    </PaintingProvider>
  </Provider>,
  document.getElementById('root')
)
